import React, { useContext } from "react";
import clsx from "clsx";
import UiContext from "@UiContext";
import { Divide as UiHamburger } from "hamburger-react";

import styles from "./Hamburger.styles";

const Hamburger = () => {
	const css = styles();
	const [ui, setUi] = useContext(UiContext);
	const { mobileMenuOpen } = ui;

	const handleToggle = () => {
		setUi(prevState => ({ ...prevState, mobileMenuOpen: !mobileMenuOpen }));
	};

	return (
		<div className={clsx(css.hamburger, "mco-view-component-hamburger")}>
			<UiHamburger size={24} toggled={mobileMenuOpen} toggle={handleToggle} />
		</div>
	);
};

export default Hamburger;
